import './NewsCarouselItem.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { get, injectImageResolution } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import RouterLink from '../atoms/RouterLink';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useContext, useRef } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
var NewsCarouselItem = function NewsCarouselItem(_ref) {
  var title = _ref.title,
    introText = _ref.introText,
    image = _ref.image,
    variant = _ref.variant,
    url = _ref.url,
    date = _ref.date,
    category = _ref.category,
    showCarousel = _ref.showCarousel,
    eventsAnalytics = _ref.eventsAnalytics,
    params = _ref.params;
  var itemWrapperRef = useRef(null);
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var showImage = variant === 'WithImage' && image;
  var showForDefaultItem = variant === 'WithImage' || variant === 'Default';
  var currentLang = get(sitecoreContext, 'language');
  var setDateFormat = function setDateFormat(date, lang) {
    return new Date(date).toLocaleDateString(lang, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: showForDefaultItem && !showCarousel ? itemWrapperWithoutCarousel : itemWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(showForDefaultItem ? styleForDefaultItem : variant === 'VerticalList' ? styleForList : styleForGrid, " ").concat(commonStyles),
    ref: itemWrapperRef
  }, showImage ? /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    href: url,
    linktype: 'internal',
    linksTarget: '',
    title: title,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title]);
    }
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: "".concat(injectImageResolution(image, 460, 259))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(image, 460, 346)),
    alt: title
  })))) : variant === 'Default' ? null : /*#__PURE__*/React.createElement("div", {
    className: "".concat(variant === 'Grid' ? 'date-grid-container' : 'date-list-container')
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, date && /*#__PURE__*/React.createElement("div", {
    className: "date-grid-list-wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date",
    field: {
      value: setDateFormat(date, currentLang)
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, category && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date-title",
    field: {
      value: category[0].toUpperCase()
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "text-container"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "date-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, date && showForDefaultItem && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "date",
    field: {
      value: setDateFormat(date, currentLang)
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "title-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, title && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RouterLink, {
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title]);
    },
    href: url,
    linktype: 'internal',
    linksTarget: '',
    title: title
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "title",
    field: {
      value: title
    }
  })))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "description-wrapper",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, introText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: {
      value: introText
    }
  }))))));
};
var itemWrapperWithoutCarousel = "izx6ka5";
var itemWrapper = "i12r50qe";
var styleForGrid = "s1ncvh2v";
var styleForList = "s1u2hpl0";
var styleForDefaultItem = "s1ifsvw0";
var commonStyles = "c1bclb3l";
export default NewsCarouselItem;